import { Box, Stack, Typography } from "@mui/material";

import cloudzeroLogo from "../../../../../assets/cloudzero-logo.svg";
import cloudzeroLogoDarkMode from "../../../../../assets/cloudzero-logo-white.svg";
import { useDarkThemeCheck } from "../../../../../Components/hooks/useDarkThemeCheck";

const CloudZeroAssetsTabHeader = () => {
  const isDarkMode = useDarkThemeCheck();

  return (
    <Stack direction="row" justifyContent="space-between" sx={{ pt: 2, pb: 2.5 }}>
      <Typography variant="h1" data-cy="cloud-zero-header">
        <Box
          component="img"
          src={isDarkMode ? cloudzeroLogoDarkMode : cloudzeroLogo}
          sx={{ height: "0.8em", width: "auto", mr: 1 }}
          data-cy="cloudzero-logo"
          aria-hidden
          alt-text="CloudZero logo"
        />
        CloudZero
      </Typography>
    </Stack>
  );
};

export default CloudZeroAssetsTabHeader;
